import {IDotRezSsrToAdd} from "../../data-contracts/requests/booking/update-ssrs.request";
import {DotRezGraphQLMutationBuilder} from "../dot-rez-query-builder";


export interface IDotRezSsrsAddMutationResponseDataV2 {

    ssrsAddv2: Array<{
        ssrKey: string;
    }>
}

export interface IDotRezSsrsAddMutationResponseDataV3 {

    ssrsAddv3: Array<{
        ssrKey: string;
    }>
}


export function addSsrsGraphQLMutation(ssrsToAdd: IDotRezSsrToAdd[], queryBuilder: DotRezGraphQLMutationBuilder, dotRezMigrationEnabled: boolean): DotRezGraphQLMutationBuilder {
    if (ssrsToAdd.length === 0) {
        return queryBuilder;
    }

    let graphQLFunctionName = 'ssrsAddv2';
    if(dotRezMigrationEnabled) {
        graphQLFunctionName = 'ssrsAddv3';
    }

    const variableName = 'sellSsrsRequest';
    queryBuilder.addMutation(`
                mutation sellSsr($${variableName}: Input_SsrByKeysRequestv2) {
                    ${graphQLFunctionName}(request: $${variableName}){
                        ssrKey
                    }
                }
            `, {
        name: variableName,
        value: {
            keys: ssrsToAdd
        }
    });

    return queryBuilder;
}
